import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flashes"
}
const _hoisted_2 = ["onClick"]

import { useFlashes } from "../flashes";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { flashes, dismiss } = useFlashes();

return (_ctx: any,_cache: any) => {
  return (_unref(flashes).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flashes), (flash, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass('flash flash-' + flash.type),
            key: index,
            onClick: ($event: any) => (_unref(dismiss)(flash))
          }, [
            _createElementVNode("p", null, _toDisplayString(flash.message), 1)
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})